import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { CircleQuestionMark, Copy, Save } from 'lucide-react';
import { Badge } from "@/components/ui/badge";
import { Button } from '@/components/ui/button';
import { Question } from './revInterviewQuest';

interface IGeneratedQuestionsSection {
  copySuccess: boolean,
  results: Question[] | null,
  userId: string,
  handleCopy: () => void
}

function GeneratedQuestionsSection({ copySuccess, results, userId, handleCopy }: IGeneratedQuestionsSection) {
  return (
    <div className="bg-white p-6 rounded-2xl shadow-xl border border-gray-100 h-auto">
      {!results ? (
        <div className="h-full flex flex-col items-center justify-center text-gray-400">
          <span className="text-5xl mb-4">🎯</span>
          <p>Your predicted questions will appear here.</p>
        </div>
      ) : (
        <div className="space-y-6">
          <Accordion
              type="single"
              collapsible
              className="w-full mr-2 md:mr-0"
          >
            <AccordionItem value={"Technical Focus"}>
              <AccordionTrigger className="text-lg pl-0 pr-0 pt-1 pb-1">
                Click the question to view the answer...
              </AccordionTrigger>
              <AccordionContent>
                <Accordion
                    type="single"
                    collapsible
                    className="w-full mr-2 md:mr-0"
                >
                  {results.map((q, i) => 
                    {
                      return (
                        <AccordionItem value={q.question} key={i}>
                          <AccordionTrigger className="text-sm pl-2 bg-gray-200">
                            {
                              <div className="flex flex-row gap-2 items-start">
                                <Badge variant="default" className='mt-1 bg-indigo-400'>
                                  <CircleQuestionMark data-icon="inline-start" size={18} />
                                  <span className='ml-2'>{(i + 1).toString()}</span>
                                </Badge>
                              {q.question}
                              </div>
                              
                            }
                          </AccordionTrigger>
                          <AccordionContent>
                            <div className="text-sm space-y-3">
                              <p className='mt-2'><span className="text-gray-500 font-medium">The Answer:</span> {q.answer}</p>
                            </div>
                          </AccordionContent>
                        </AccordionItem>
                      )
                    })
                  }
                </Accordion>
              </AccordionContent>
            </AccordionItem>
          </Accordion>
          
          <div className="flex justify-end mt-4 space-x-3">
              <Button 
                  variant="outline"
                  onClick={handleCopy}
                  disabled={!results}
                  className="flex items-center space-x-2"
              >
                  <Copy className="h-4 w-4" />
                  <span>{copySuccess ? 'Copied!' : 'Copy to Clipboard'}</span>
              </Button>
              {/* This button is a placeholder for future Firestore saving logic */}
              {/* <form action={"/api/saveNewDraft"} method="POST">
                <input type="hidden" name="userId" value={data.id} />
                <input type="hidden" name="title" value={draft.title} />
                <input type="hidden" name="userRole" value={draft.userRole} />
                <input type="hidden" name="recipientRole" value={draft.recipientRole} />
                <input type="hidden" name="tone" value={draft.tone} />
                <input type="hidden" name="details" value={draft.details} />
                <input type="hidden" name="generatedDraft" value={generatedEmail} /> */}

              <Button className="bg-sky-500 hover:bg-sky-600 text-white flex items-center space-x-2" 
                disabled={!results || !userId}
                // onClick={handleSaveDraft}
              >
                  <Save className="h-4 w-4" />
                  <span>Save Draft</span>
              </Button>
              {/* </form> */}
            </div>
        </div>
      )}
    </div>
  )
}

export default GeneratedQuestionsSection